import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Gestionale Base';
  baseLanguage = 'it';

  private tooltipInterval!: number;

  constructor(private transloco: TranslocoService) { }

  ngOnInit() {
    const savedLang = localStorage.getItem('language');
    this.baseLanguage = savedLang ?? 'it';

    if (!savedLang) {
      localStorage.setItem('language', 'it');
    }

    this.transloco.setActiveLang(this.baseLanguage);

    this.tooltipInterval = window.setInterval(() => {
      document.querySelectorAll('.ng-option-label').forEach((el: any) => {
        if (el.parentNode) {
          el.parentNode.title = el.textContent;
        }
      });
    }, 1000);
  }

  ngOnDestroy() {
    if (this.tooltipInterval) {
      clearInterval(this.tooltipInterval);
    }
  }
}
